module.exports = __webpack_public_path__ + "images/Grey_Square-75211c5fae7e301bef7d60cbfa867330.png";